import type { SVGProps } from 'react';
const SvgMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
    viewBox="0 0 512 512"
    {...props}
  >
    <path
      d="M133.333 307.733c-15.644 0-27.377-5.333-35.2-16-7.822-10.666-11.733-21.333-11.733-32 0-13.511 3.556-24.177 10.667-32 7.111-7.822 14.933-12.089 23.466-12.8 40.534-2.844 73.956-4.8 100.267-5.866 26.311-1.067 51.2-1.956 74.667-2.667 23.466-.711 50.844-1.422 82.133-2.133 15.644 0 27.556 4.8 35.733 14.4 8.178 9.6 12.267 19.377 12.267 29.333s-4.267 21.689-12.8 35.2c-8.533 13.511-17.067 20.267-25.6 20.267-29.867-1.423-64.356-1.067-103.467 1.066-39.111 2.134-89.244 3.2-150.4 3.2Z"
      style={{
        fillRule: 'nonzero',
      }}
    />
  </svg>
);
export default SvgMinus;
